export const defaultNotificationDomainState = {
    userAcceptedCookiesAt: undefined
};
